<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <card>
          <div slot="header">
            <h4 class="card-title">{{ $t("EaaAccount.Store_Account_Information", { type: actionType}) }} </h4>
          </div>
          <div>
            <fg-input
              :label="$t('EaaAccount.Name')"
              required
              v-model="model.name"
              v-validate="modelValidations.name"
              :error="getError('full name')"
              name="full name"
            ></fg-input>

            <fg-input
              :label="$t('EaaAccount.Email')"
              required
              v-model="model.email"
              v-validate="modelValidations.email"
              :error="getError('email')"
              name="email"
              type="email"
            ></fg-input>

            <fg-input
              :label="$t('EaaAccount.Password')"
              required
              name="password"
              v-model="model.password"
              v-validate="modelValidations.password"
              ref="password"
              :error="getError('password')"
              type="password"
            ></fg-input>

            <fg-input
              v-if="userType === 'eaa'"
              label="Confirm Password"
              required
              type="password"
              name="confirm"
              v-validate="'required|confirmed:password'"
              :error="getError('confirm')"
              v-model="model.confirmPassword"
            ></fg-input>
          </div>
          <div class="d-flex justify-content-center">
            <n-button native-type="submit" @click.native.prevent="validate" type="primary">{{$t('EaaAccount.Submit_Account_Information')}}</n-button>
          </div>
        </card>
      </form>

      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        :class="modals.class"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Validator } from 'vee-validate';
import { Checkbox, Radio } from "src/components/index";
import { Modal } from "src/components";
// import CryptoJS from "crypto-js";

Validator.extend('passwordCustom', {
  getMessage: `密碼長度應至少8 碼以上，並且混合大小寫英文字母、數字及特殊符號`,
  validate: value => validatePassword(value)
});

function validatePassword(password) {
  if (password && password.length < 8) return false;
  // 條件1: 包含英文字母和數字
  const cond1 = /(?=.*[a-zA-Z])(?=.*\d)/.test(password);
  // 條件2: 包含英文字母大小寫
  const cond2 = /(?=.*[a-z])(?=.*[A-Z])/.test(password);
  // 條件3: 包含符號
  const cond3 = /(?=.*[\W_])/.test(password);

  const passedConditions = [cond1, cond2, cond3].filter(Boolean).length;

  return passedConditions >= 2;
}

export default {
  components: {
    Checkbox,
    Radio,
    Modal
  },
  // computed: {
  //   userId: function() {
  //     console.log("the user Id is ", this.$store.getters.userId);
  //     // Encrypt 加密
  //     // var cipherText = CryptoJS.AES.encrypt(
  //     //   "my message",
  //     //   "secretkey123"
  //     // ).toString();
  //     // console.log(cipherText)
  //     // // Decrypt 解密
  //     // var bytes = CryptoJS.AES.decrypt(cipherText, "secretkey123");
  //     // var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //     // console.log(originalText); // 'my message'
  //     return this.$store.getters.userId;
  //   }
  // },
  data() {
    return {
      myvalue: 'shit',
      model: {
        email: "",
        password: "",
        confirmPassword: "",
        name: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          // min: 8,
          passwordCustom: true
        }
      },
      modals: {
        content: "",
        mini: false,
        class: "modal-danger"
      }
    };
  },
  computed: {
    actionType() {
      const isEAA = this.userType === "eaa" || this.$route.params.eaaId
      return isEAA ? this.$t('EaaAccount.Update') : this.$t('EaaAccount.Add')
    },
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  mounted() {
    let self = this;
    if (this.userType === "eaa") {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/eaa/eaa-account`)
        .then(response => {
          self.model.email = response.data.email;
          self.model.name = response.data.name;
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.modals.class = 'modal-danger';
          this.modals.mini = true;
        });
    } else {
      if (this.$route.params.eaaId) {
        if (this.userType === "si" || this.userType === "gaa") {
          return axios
            .get(
              `${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts/${this.$route.params.eaaId}`
            )
            .then(response => {
              self.model.email = response.data.email;
              self.model.name = response.data.name;
              return response.data;
            })
            .catch(e => {
              if (e && e.data && e.data.message)
                this.modals.content = e.data.message;

              this.modals.class = 'modal-danger';
              this.modals.mini = true;
            });
        } else {
          this.modals.content = this.$t('EaaAccount.Message.Do_not_have_permission');
          this.modals.class = 'modal-danger';
          this.modals.mini = true;
        }
      }
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          if (this.userType === "eaa") {
            return axios
              .put(`${process.env.VUE_APP_APIHOST}/eaa/eaa-account`, {
                email: this.model.email,
                name: this.model.name,
                password: this.model.password
              })
              .then(response => {
                if (response && response.data && response.data.id) {
                  // this.$router.push("/eaa-accounts");
                  this.modals.content = this.$t('EaaAccount.Message.Update_account_successfully');
                  this.modals.class = 'modal-success';
                  this.modals.mini = true;
                } else {
                  this.modals.content = this.$t('EaaAccount.Message.Update_account_failed');
                  this.modals.class = 'modal-danger';
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;

                this.modals.class = 'modal-danger';
                this.modals.mini = true;
              });
          } else if (this.userType === "gaa" || this.userType === "si") {
            if (this.$route.params.eaaId) {
              return axios
                .put(
                  `${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts/${this.$route.params.eaaId}`,
                  {
                    email: this.model.email,
                    name: this.model.name,
                    password: this.model.password
                  }
                )
                .then(response => {
                  if (response && response.data && response.data.id) {
                    this.$router.push("/eaa-accounts");
                  } else {
                    this.modals.class = 'modal-danger';
                    this.modals.content = this.$t('EaaAccount.Message.Update_account_failed');
                    this.modals.mini = true;
                  }
                  return response.data;
                })
                .catch(e => {
                  if (e && e.data && e.data.message)
                    this.modals.content = e.data.message;

                  this.modals.class = 'modal-danger';
                  this.modals.mini = true;
                });
            } else {
              return axios
                .post(
                  `${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts/`,
                  {
                    email: this.model.email,
                    name: this.model.name,
                    password: this.model.password
                  }
                )
                .then(response => {
                  if (response && response.data && response.data.id) {
                    this.$router.push("/eaa-accounts");
                  } else {
                    this.modals.class = 'modal-danger';
                    this.modals.content = this.$t('EaaAccount.Message.Create_account_failed');
                    this.modals.mini = true;
                  }
                  return response.data;
                })
                .catch(e => {
                  if (e && e.data && e.data.message)
                    this.modals.content = e.data.message;

                  this.modals.class = 'modal-danger';
                  this.modals.mini = true;
                });
            }
          }
        } else {
          console.log("validate failed");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>
<style>
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>